import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AlertStateFacade } from '../../state/alert/alert-state-facade';
import { getErrorMessage } from './effect-helpers';

@Injectable({ providedIn: 'root' })
export class StoreErrorHandler {
  readonly #alertStateFacade = inject(AlertStateFacade);
  readonly #translocoService = inject(TranslocoService);

  public handleBackendError = (errorResponse: unknown, defaultMessage?: string) =>
    this.#alertStateFacade.addErrorAlert({ message: this.#translocoService.translate(getErrorMessage(errorResponse, defaultMessage)) });
}
